import { transportTypeFilterOptionsSelector } from '@/scopes/prices/components/selectors'
import { BusSelector } from '@/scopes/prices/components/TransportSelector/BusSelector'
import { FlightSelector } from '@/scopes/prices/components/TransportSelector/FlightSelector'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'

export function TransportSelector() {
  const { selectedValue } = usePricesSelector(transportTypeFilterOptionsSelector)

  if (!selectedValue) {
    return null
  }
  if (selectedValue === 'Bus') {
    return <BusSelector />
  }
  if (selectedValue === 'Flight') {
    return <FlightSelector />
  }
  if (selectedValue === 'SelfDrive') {
    return null
  }
}
